import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Avatar
} from '@mui/material';
import {
  BarChart as BarChartIcon,
  Settings as DiagSettingsIcon,
  Home as DiagHomeIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/Navbar';
import { createAllPhaseMenuGroups } from '../../../utils/createAllPhaseMenuGroups';

export default function DiagnosisHome({ currentPhase = 'diagnosis', onPhaseChange }) {
  const navigate = useNavigate();
  const [currentCourseId, setCurrentCourseId] = useState(1);

  const featureCards = [
    {
      title: '設定',
      description: '其他設定',
      icon: DiagSettingsIcon,
      color: '#607d8b',
      path: '/teacher/diagnosis/settings'
    }
  ];

  // A-3: 使用分層架構選單
  const allPhaseMenuGroups = createAllPhaseMenuGroups('diagnosis', 'diagnosis', navigate);

  return (
    <div className="teacher-layout diagnosis-home-container">
      <div className="main-content-v2">
        <Navbar 
          allPhaseMenuGroups={allPhaseMenuGroups}
          currentPhase={currentPhase || 'diagnosis'}
          onPhaseChange={(phase) => {
            if (onPhaseChange) {
              onPhaseChange(phase);
            } else {
              if (phase === 'preparation') {
                navigate('/teacher/preparation');
              } else if (phase === 'implementation') {
                navigate('/teacher/implementation');
              } else if (phase === 'diagnosis') {
                navigate('/teacher/diagnosis');
              }
            }
          }}
          currentCourseId={currentCourseId}
          onCourseChange={(newCourseId) => {
            setCurrentCourseId(newCourseId);
            // 這裡可以添加課程切換的邏輯
          }}
        />
        
        <div className="class-header-row">
          <h1 className="main-title">課後診斷</h1>
        </div>

        {/* 功能卡片 */}
        <div className="activity-card-list grid-responsive">
          {featureCards.map((card, index) => (
            <div
              className="activity-card"
              key={index}
              onClick={() => navigate(card.path)}
              style={{ 
                position: 'relative', 
                background:'#fff', 
                boxShadow:'0 2px 8px rgba(44,44,80,0.08)', 
                borderRadius: '12px', 
                border:'1.5px solid #e0e0e0',
                cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s',
                minHeight: '200px',
                maxHeight: '200px',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 12px rgba(44,44,80,0.12)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 8px rgba(44,44,80,0.08)';
              }}
            >
              <Avatar
                sx={{
                  width: 60,
                  height: 60,
                  bgcolor: card.color,
                  mx: 'auto',
                  mb: 2,
                  mt: 1
                }}
              >
                <card.icon sx={{ fontSize: 30, color: 'white' }} />
              </Avatar>
              <div className="activity-name" style={{ fontSize: '1.2rem', marginBottom: '8px' }}>
                {card.title}
              </div>
              <div style={{ 
                fontSize: '0.9rem', 
                color: '#666', 
                lineHeight: '1.4',
                padding: '0 8px',
                textAlign: 'center'
              }}>
                {card.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
